/**
 * Format currency value to Indian Rupee format
 */
export const formatCurrency = (value: number, decimals: number = 0): string => {
  const absValue = Math.abs(value);
  return `₹${absValue.toLocaleString('en-IN', { maximumFractionDigits: decimals })}`;
};

/**
 * Format currency with +/- sign
 */
export const formatCurrencyWithSign = (value: number, decimals: number = 0): string => {
  const sign = value >= 0 ? '+' : '-';
  return `${sign}${formatCurrency(value, decimals)}`;
};

/**
 * Format residual risk with appropriate sign and color
 * Returns object with formatted value and color class
 */
export const formatResidualRisk = (risk: number, decimals: number = 0) => {
  const isNegative = risk < 0;
  const formattedValue = isNegative 
    ? `-${formatCurrency(risk, decimals)}`
    : formatCurrency(risk, decimals);
  
  const colorClass = isNegative ? 'text-green-600' : 'text-red-600';
  
  return {
    value: formattedValue,
    colorClass,
    isNegative,
  };
};

/**
 * Get color class for PnL (profit/loss)
 */
export const getPnLColorClass = (value: number): string => {
  if (value > 0) return 'text-green-600';
  if (value < 0) return 'text-red-600';
  return 'text-gray-600';
};

/**
 * Get residual risk card styling (background and border)
 * Returns appropriate theme based on whether risk is negative (profit locked) or positive (capital at risk)
 */
export const getResidualRiskCardTheme = (risk: number): string => {
  return risk < 0 
    ? 'bg-green-50 border-green-200'  // Negative risk = profit locked in
    : 'bg-red-50 border-red-200';      // Positive risk = capital at risk
};
